import firebase from 'firebase'
import { UUID } from '../util/prototypes';
// // Firebase App (the core Firebase SDK) is always required and
// // must be listed before other Firebase SDKs

// // Add the Firebase products that you want to use
const firebaseConfig = {
    apiKey: "AIzaSyAb2cWpTRbjhbsuvvGqi8VrzFs_SfO6bzg",
    authDomain: "ui-designer-da356.firebaseapp.com",
    databaseURL: "https://ui-designer-da356.firebaseio.com",
    projectId: "ui-designer-da356",
    storageBucket: "ui-designer-da356.appspot.com",
    messagingSenderId: "732442900408",
    appId: "1:732442900408:web:56f3e22f1904cd7d14c14d",
    measurementId: "G-NLJL2202JR"
};
const app = firebase.initializeApp(firebaseConfig);
const db = firebase.firestore(app);

export const AppService = {
    async loginWithGoogle() {
        const provider = new firebase.auth.GoogleAuthProvider();
        return firebase.auth().signInWithPopup(provider)
    },
    async addComponent(payload) {
        return db.collection("components").add(payload);
    },
    async fetchComponents() {
        const authUser = JSON.parse(localStorage.getItem('authUser'));
        const uid = authUser && authUser.user ? authUser.user.uid : '';
        return db.collection('components').where("uid", "==", uid).orderBy("timestamp", "desc").get();
    },
    componentsOnChange(callback) {
        const authUser = JSON.parse(localStorage.getItem('authUser'));
        const uid = authUser && authUser.user ? authUser.user.uid : '';
        return db.collection('components').where("uid", "==", uid).orderBy("timestamp", "desc").onSnapshot(callback);
    },
    allComponentsOnChange(callback) {
        return db.collection('components').onSnapshot(callback);
    },
    addGradient(gradient) {
        return db.collection("gradients").add(gradient);
    },
    addBoxShadow(shadow) {
        return db.collection("boxshadows").add(shadow);
    },
    addBorderRadius(shadow) {
        return db.collection("borderradius").add(shadow);
    },
    addTypography(shadow) {
        return db.collection("typography").add(shadow);
    },
    addGrid(grid) {
        return db.collection("grids").add(grid);
    },
    allBoxShadowsOnChange(callback) {
        return db.collection('boxshadows').onSnapshot(callback);
    },
    allGradientsOnChange(callback) {
        return db.collection('gradients').onSnapshot(callback);
    },
    allBorderRadius(callback) {
        return db.collection('borderradius').onSnapshot(callback);
    },
    allTypography(callback) {
        return db.collection('typography').onSnapshot(callback);
    },
    allGridsOnChange(callback) {
        return db.collection('grids').onSnapshot(callback);
    },
    updateComponent({ docId, attrs }) {
        return db.doc("components/" + docId).update({ ...attrs });
    },
    deleteComponent({ doc }) {
        return db.collection('components').doc(doc.id).delete();
    }
}